import { Card, Stack, Typography } from '@mui/material';
import { COLOR_ACCENT, COLOR_BG, COLOR_SECONDARY } from 'shared';

import { PageNavigationMenuItem, PageNavigationMenuProps } from './page-navigation-menu';

type PageNavigationMenuCardProps = PageNavigationMenuProps & {
  isMobileOpen: boolean;
  handleClose: () => void;
};

export const PageNavigationMenuCard = ({
  activeSection,
  isMobile,
  isMobileOpen,
  handleClose,
  items,
}: PageNavigationMenuCardProps) => (
  <Card
    sx={(theme) => ({
      display: { xs: isMobile && isMobileOpen ? 'block' : 'none', md: isMobile ? 'none' : 'block' },
      p: theme.spacing('21px', '20px', '18px', 0),
      width: 246,
      bgcolor: COLOR_BG,
    })}
  >
    <Stack spacing={1}>
      {items.map(({ title, id }: PageNavigationMenuItem) => (
        <Typography
          key={title}
          component="a"
          variant="body2"
          color={id === activeSection ? COLOR_ACCENT : COLOR_SECONDARY}
          borderLeft={id === activeSection ? `2px solid ${COLOR_ACCENT}` : 'none'}
          pl={id === activeSection ? 1.25 : 1.5}
          href={`#${id}`}
          onClick={handleClose}
          sx={{
            position: 'relative',
            zIndex: 5,
            cursor: 'pointer',
            '&:hover': { color: COLOR_ACCENT },
          }}
        >
          {title}
        </Typography>
      ))}
    </Stack>
  </Card>
);
